/**
 * TYPES
 */
export const TYPES = {
    STRING: 'String',
    NUMBER: 'Number',
    BOOLEAN: 'Boolean',
    ARRAY: 'Array',
    ENTITY: 'Object',
    FUNCTION: 'Function',
}

/**
 * FORMATS
 */
export const FORMATS = {
    NONE: '',
    DATE: 'date',
    TIME: 'time',
    EMAIL: 'email',
    HTML: 'HTML',
    URL: 'URL',
    IMG: 'IMG',
    COLOR: 'COLOR',
    TOKENS: 'TOKENS'
}

/**
 * CHECK
 */
export const CHECK = Object.values(TYPES).reduce((obj, name) => {
    obj['is' + name] = x => toString.call(x) == '[object ' + name + ']';
    return obj;
}, {});

/**
 * Content Type
 */
export class ContentType {

    constructor(schema) {
        this._schema = schema
    }

    checkType({ type, item }, data) {
        let valid = true
        let validChildren = true
        if (item) {
            const child = new ContentType(item)
            switch (type) {
                case TYPES.ARRAY:
                    valid = CHECK['is' + type](data)
                    validChildren = data.every(element => child.validate(element))
                    break
                case TYPES.ENTITY:
                    valid = CHECK['is' + type](data)
                    validChildren = child.validate(data)
                    break
                case TYPES.NUMBER:
                    valid = CHECK['is' + type](data.value)
                    validChildren = true
                    break
                default:
                    valid = true
                    validChildren = true;
            }
        }
        return valid && validChildren
    }

    /**
     * Validate entity data
     * - Inspect required attributes only
     * - Check attributes type
     */
    validate(data) {
        const attributes = Object.entries(this._schema)
        return attributes
            .filter(([name, attr]) => attr.required === true)
            .every(([name, attr]) => data[name] !== undefined ? this.checkType(attr, data[name]) : false)
    }

    /**
     * Content Type Form
     */
    form(data) {

        const entries = Object.entries(this._schema)

        const form = entries.reduce((form, [id, field]) => {
            form[id] = Object.assign({}, field, { value: data[id] })
            return form
        }, {})

        return form
    }

    /**
     * Content Type Sections
     */
    sections(data) {

        const form = this.form(data)
        const fields = Object.values(form)
        const sections = fields.reduce((sections, field) => {
            const { section } = field
            const title = section ? section : ''
            if (!sections.hasOwnProperty(title)) sections[title] = { title, fields: [] }
            sections[title].fields.push(field)
            return sections
        }, {});

        return Object.values(sections)
    }

    /**
     * value 
     */
    value(data) {

        const fields = Object.entries(this._schema)
        const next = fields.reduce((next, [name, field]) => {

            const { type, item } = field
            const entryData = data ? data[name] : null

            switch (type) {

                case TYPES.STRING:
                    next[name] = entryData || field.default
                    break;

                case TYPES.NUMBER:
                    next[name] = entryData || field.default
                    break;

                case TYPES.BOOLEAN:
                    next[name] = entryData || field.default
                    break

                case TYPES.ENTITY:
                    const child1 = new ContentType(item)
                    next[name] = child1.value(entryData)
                    break;

                case TYPES.ARRAY:
                    if (item === TYPES.STRING) {
                        next[name] = entryData ? entryData : []
                    } else {
                        const child2 = new ContentType(item)
                        next[name] = entryData ? entryData.map(data2 => child2.value(data2)) : []
                    }
                    break;

                default:
                    next[name] = field
                    break;

            }

            return next

        }, {})

        return next
    }
}


/**
 * Content
 */
export class Content {

    constructor(type, value) {
        this.type = type
        this._type = new ContentType(type)
        this._value = value
    }

    isValid() {
        return this._type.validate(this._value)
    }

    value() {
        return this._type.value(this._value)
    }

    form() {
        return this._type.form(this._value)
    }

    sections() {
        return this._type.sections(this._value)
    }

    update(value) {
        this._value = value
    }
}